<template>
  <div class="file-dialog-container">
    <FilesTopbar />
    <FilesList />
  </div>
</template>

<script>
import FilesList from '~/components/files/FilesList';
import FilesTopbar from '~/components/files/FilesTopbar';

export default {
  components: { FilesList, FilesTopbar },
  setup() {},
};
</script>

<style scoped lang="scss">
.file-dialog-container {
  /* Style your dialog/panel here */
  display: flex;
  flex-direction: column;
  height: 100vh; /* Take full viewport height */
  width: 100%;
  position: fixed; /* Use fixed positioning */
  top: 0;
  left: 0;
  z-index: 1000; /* Ensure it's above other content */
}
</style>
